import React from "react"

const SectionResults = () => (
  <section className="res12">
    <div className="wrap">
      <h2>Proven in bundled payments</h2>
      <div className="wide12">
        <div className="w12-top">
          <div className="w12-num">
            <b>11%</b>
          </div>
          <div className="w12-txt">
            <span className="w12-lbl">Across our clients</span>{" "}
            <span className="w12-main">Bundled Payment Earnings</span>{" "}
            <span className="w12-sub">
              In the 2 most recent CMS BPCI Advanced (bundled payments)
              performance periods, our clients on average beat their target
              prices by 11%.
            </span>
          </div>
          <div className="w12-bar">
            <div
              className="a12-bar"
              role="img"
              aria-label="Client spending averaged 88 percent of the CMS target price"
            >
              <div className="a12-track">
                <div className="a12-fill" />
                <div className="a12-tgt" />
              </div>
              <div className="a12-lbls">
                <span className="l-cl">Our clients’ spending</span>
                <span className="l-tg">CMS target price</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fx-row">
        <div className="fx-card fx-case">
          <span className="fx-kicker">
            <i className="hb">HBR</i>Case study
          </span>
          <h3>Results published in Harvard Business Review</h3>
          <div className="fx-stats">
            <div>
              <b>15%</b>
              <span>below CMS target prices</span>
            </div>
            <div>
              <b>34% → 25%</b>
              <span>90-day mortality</span>
            </div>
            <div>
              <b>30% → 25%</b>
              <span>90-day readmissions</span>
            </div>
          </div>
          <a
            className="fx-btn"
            href="https://hbr.org/2021/03/how-one-hospital-has-succeeded-in-a-world-of-bundled-payments"
            target="_blank"
            rel="noopener"
          >
            Read the article in Harvard Business Review{" "}
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path
                d="M6 3h7v7M13 3L5 11"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
        <div className="fx-card fx-feature">
          <span className="fx-kicker">
            <i className="hb">HBR</i>Our research on physician incentives
          </span>
          <h3>
            Physicians Can Help Cut Costs. They Just Need the Right Incentives.
          </h3>
          <p>
            TEAM results depend on surgeons and care teams across five service
            lines. Our Harvard Business Review research shows how to align
            physician incentives with cost and quality goals.
          </p>
          <a
            className="fx-btn"
            href="https://hbr.org/2024/10/physicians-can-help-cut-costs-they-just-need-the-right-incentives"
            target="_blank"
            rel="noopener"
          >
            Read the article in Harvard Business Review{" "}
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path
                d="M6 3h7v7M13 3L5 11"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </section>
)

export default SectionResults
